import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const WorkshopCrudTable = ({
  workshops,
  metaWorkshops,
  language,
  onEdit,
  onDelete,
  onView,
  onPageChange,
}) => {
  if (!metaWorkshops) return null;

  const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = metaWorkshops;

  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  const labels = {
    name: { ar: "الاسم", en: "Name" },
    phone: { ar: "الهاتف", en: "Phone" },
    address: { ar: "العنوان", en: "Address" },
    area: { ar: "المنطقة", en: "Area" },
    description: { ar: "الوصف", en: "Description" },
    governorate: { ar: "المحافظة", en: "Governorate" },
    emergency: { ar: "طوارئ", en: "Emergency" },
      rating: { ar: "التقييم", en: "Rating" },
    actions: { ar: "الإجراءات", en: "Actions" },
    yes: { ar: "نعم", en: "Yes" },
    no: { ar: "لا", en: "No" },
  };
  console.log(workshops);
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1000px] text-center">
          <thead className="bg-muted border-b">
            <tr>
              <th className="px-6 py-4">{labels.name[language]}</th>
              <th className="px-6 py-4">{labels.phone[language]}</th>
              <th className="px-6 py-4">{labels.address[language]}</th>
              <th className="px-6 py-4">{labels.area[language]}</th>
              <th className="px-6 py-4">{labels.description[language]}</th>
              <th className="px-6 py-4">{labels.emergency[language]}</th>
               <th className="px-6 py-4">{labels.rating[language]}</th>
              <th className="px-6 py-4">{labels.actions[language]}</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {workshops?.map((w) => (
              <tr key={w.id} className="hover:bg-muted/40 transition">
                <td className="px-6 py-4">
                  <div className="flex items-center justify-center gap-3">
                    <Image
                      src={
                        w?.images?.[0]?.media_link || w?.images?.[0]?.media_link
                      }
                      alt=""
                      className="w-10 h-10 rounded-lg object-cover"
                    />
                    <span className="font-medium">{w.name}</span>
                  </div>
                </td>

                <td className="px-6 py-4 text-text-secondary">
                  {w.phone_number}
                </td>

                <td className="px-6 py-4 text-primary">
                  {" "}
                  {w.latitude && w.longitude ? (
                    <a
                      href={`https://www.google.com/maps?q=${w.latitude},${w.longitude}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline hover:text-primary/80 transition"
                    >
                      {w.address}
                    </a>
                  ) : (
                    <span className="text-text-secondary">{w.address}</span>
                  )}
                </td>

                <td className="px-6 py-4">{w?.area_name}</td>

                <td className="px-6 py-4">{w.description}</td>

                <td className="px-6 py-4">
                  <span
                    className={`inline-flex px-3 py-1 rounded-full text-sm ${
                      w.is_emergency_provided
                        ? "bg-success/10 text-success"
                        : "bg-muted text-text-secondary"
                    }`}
                  >
                    {w.is_emergency_provided
                      ? labels.yes[language]
                      : labels.no[language]}
                  </span>
                </td>

                     <td className="px-6 py-4">{w.review_count}</td>

                <td className="px-6 py-4">
                  <div className="flex justify-center gap-2">
                    <button
                      onClick={() => onView(w)}
                      className="p-2 rounded-lg hover:bg-info/10 text-info transition"
                    >
                      <Icon name="Eye" size={16} />
                    </button>
                    <button
                      onClick={() => onEdit(w)}
                      className="p-2 rounded-lg hover:bg-primary/10 text-primary transition"
                    >
                      <Icon name="Edit2" size={16} />
                    </button>
                    <button
                      onClick={() => onDelete(w)}
                      className="p-2 rounded-lg hover:bg-error/10 text-error transition"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
        <span className="text-sm text-text-secondary">
          {from}-{to} من {total}
        </span>

        <div className="flex gap-1 flex-wrap">
          <Button
            size="sm"
            variant="outline"
            disabled={!prev_page_url}
            onClick={() => onPageChange(current_page - 1)}
          >
            السابق
          </Button>

          {pages.map((page) => (
            <Button
              key={page}
              size="sm"
              variant={page === current_page ? "default" : "outline"}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ))}

          <Button
            size="sm"
            variant="outline"
            disabled={!next_page_url}
            onClick={() => onPageChange(current_page + 1)}
          >
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkshopCrudTable;
